angular.module('leanlaw').controller('TimekeeperProductivityCtrl', ['$scope', '$window', '$rootScope', '$filter', '$state', '$stateParams', "alerts", 'userService', 'reportsService', 'singleRequest', 'clientMatterManager', "exportJson", "messageBus", function ($scope, $window, $rootScope, $filter, $state, $stateParams, alerts, userService, reportsService, singleRequest, clientMatterManager, exportJson, messageBus) {
  $scope.filter = {};
  $scope.search = "";
  $scope.sort = 'user.name';
  $scope.reverse = false;
  $scope.loading = true;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const exp = $scope.data.filtered.reduce((accum, c) => {
      const item = {
        "User": c.user.name
      };
      if ($scope.me.adjustments) {
        item["Billable Hours Worked"] = $filter("hoursDecimal")(c.data.hours.trackedHours);
        item["Billable Hours Write-down"] = $filter("hoursDecimal")(c.data.hours.writedown);
      }
      item["Billable Hours Total"] = $filter("hoursDecimal")(c.data.hours.billable);
      item["Fixed Fee Hours"] = $filter("hoursDecimal")(c.data.hours.charges);
      item["Non-Billable Hours"] = $filter("hoursDecimal")(c.data.hours.nonBillable);
      item["Total Hours"] = $filter("hoursDecimal")(c.data.hours.total);
      if ($scope.me.adjustments) {
        item["Worked Hours Value"] = $filter("amount")(c.data.amounts.trackedHours);
      }
      item["Fixed Fee Hours Value"] = $filter("amount")(c.data.amounts.chargesHours);
      item["Billable Hours Value"] = $filter("amount")(c.data.amounts.hours);
      if ($scope.me.adjustments) {
        item["Write-down"] = $filter("amount")(c.data.amounts.writedown);
      }
      item["Expenses"] = $filter("amount")(c.data.amounts.expenses);
      accum.push(item);
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.return = function () {
    $window.history.back();
  };

  // MatterId may be optional
  $scope.gotoDetail = function (user) {
    if (!user.id) return;
    if ($stateParams.clientId || $stateParams.matterId) {
      return $state.go("reports.productivity-detail", {
        ...$stateParams,
        userId: user.id,
        report: $scope.title,
        return: "reports.timekeeper-productivity"
      });
    }
    $state.go("reports.client-matter-productivity", {
      userId: user.id,
      report: `Timekeeper Productivity`,
      return: "reports.timekeeper-productivity"
    });
  };
  activate();

  ///////////////////////////////////////

  function activate() {
    userService.me().then(me => {
      $scope.me = me;
    });
    if ($stateParams.matterId) {
      $scope.back = true;
      clientMatterManager.getMatter($stateParams.matterId).then(matter => {
        $scope.title = matter.label;
      });
    } else if ($stateParams.clientId) {
      $scope.back = true;
      clientMatterManager.getClient($stateParams.clientId).then(client => {
        $scope.title = client.label;
      });
    }
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.filter = Object.assign($scope.filter, payload);
      // Necessary to set this value for the requests
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.scope = $scope.filter.filter.scope;
      $scope.filter.startDate = $scope.filter.filter.range.startDate;
      $scope.filter.endDate = $scope.filter.filter.range.endDate;
      $scope.filter.scopeAccount = $scope.filter.filter.scopeAccount ? $scope.filter.filter.scopeAccount.id : null;
      // console.log("f", $scope.filter);
      if (payload.filter.range) {
        filterClientEntries();
      }
    });
    $scope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
    });

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage("filterDependency-ready", true);
  }
  function filterClientEntries() {
    const query = reportsService.queryFromFilter($scope.filter);
    query.data = "services,expenses,hours";
    query.primary = 'users';
    query.clientId = $stateParams.clientId;
    query.matterId = $stateParams.matterId;
    query.reportType = 'productivity';
    $scope.loading = true;
    singleRequest.apiCall("timekeeper-productivity", true).getReport(query).then(data => {
      if (!data) return; // happens if we were canceled
      $scope.data = data;
      const unassigned = $scope.data.users.filter(u => u.user.name === "Unassigned");
      if ($scope.data.unallocated && !unassigned.length) {
        $scope.data.users.push({
          user: {
            name: "Unassigned"
          },
          data: {
            ...$scope.data.unallocated
          }
        });
        ['amounts', 'hours'].forEach(type => {
          Object.keys($scope.data.data[type]).forEach(a => {
            $scope.data.data[type][a] = $scope.data.data?.[type][a] + $scope.data.unallocated?.[type][a];
          });
        });
      }
      $scope.data.users.forEach(adjustData);
      adjustData(data);
      $scope.loading = false;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  function adjustData(item) {
    const {
      amounts
    } = item.data;
    amounts.writedownPercent = amounts.trackedHours ? Math.round(1000 * amounts.writedown / amounts.trackedHours) / 10 : '-';
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("timekeeper-productivity");
    deactivate();
  });

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filtered = $filter('orderBy')($filter('filter')($scope.data.users, $scope.search), $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.users', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);